module.exports = __webpack_public_path__ + "static/media/map.36109dff.svg";